import { GetterTree, MutationTree, ActionTree } from "vuex/types/index";
import { Transaction } from "@foxone/api/src/models/defi";
import utils from "@/utils";

const state = () => ({
  transactions: [],
  hasNext: true
});

export type TransactionsState = ReturnType<
  () => {
    transactions: Transaction[];
    hasNext: boolean;
  }
>;

const getters: GetterTree<TransactionsState, {}> = {
  getGroupedSnapshots(state) {
    return state.transactions.reduce((group, transaction) => {
      const date = utils.date.formatDate(
        +transaction.created_at * 1000,
        "YYYY/MM/DD"
      );
      if (!group[date]) {
        group[date] = [];
      }
      group[date].push(transaction);
      return group;
    }, {});
  }
};

const mutations: MutationTree<TransactionsState> = {
  SET_TRANSACTIONS(state, data) {
    state.transactions = data;
  },
  SET_HAS_NEXT(state, value) {
    state.hasNext = value;
  },
  REMOVE_TRANSACTIONS(state) {
    state.transactions = [];
    state.hasNext = true;
  }
};

const actions: ActionTree<TransactionsState, {}> = {
  async loadTransactions({ commit, state }, { reload }) {
    // let offset = 0;
    // if (!reload) {
    //   offset = state.transactions.length;
    // }
    // const transactions = await this.$api.defi.getTransitions({
    //   offset,
    //   limit: 10
    // });
    // if (reload) {
    //   commit("SET_TRANSACTIONS", transactions);
    // } else {
    //   commit("SET_TRANSACTIONS", [...state.transactions, ...transactions]);
    // }
    // if (transactions.length === 0) {
    //   commit("SET_HAS_NEXT", false);
    // }
  },
  removeTransactions({ commit }) {
    commit("REMOVE_TRANSACTIONS");
    commit("SET_HAS_NEXT", true);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
